import styled from 'styled-components';

const FieldValue = styled.div`
    color: ${props => props.theme.colors.darkgray};
`;

export default FieldValue;



// WEBPACK FOOTER //
// ./src/components/atoms/text/FieldValue.js